import axios from './axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import directive from './directive'
import store from './store'

import VueSignaturePad from 'vue-signature-pad';
import VueFinalModal from 'vue-final-modal'
import Vue3TouchEvents from "vue3-touch-events";
import VDynamicModal from '@/components/common/VDynamicModal'

// import './assets/css/common.new.css'
// import './assets/css/contents.new.css'
//import './assets/css/contents.petperMint.css'
import './assets/css/common.css'
import './assets/css/contents.css'
import './assets/css/layout.css'

let app = createApp(App);
directive(app);
app.config.devtools = true
app.use(store);
app.use(VueFinalModal())
app.use(VueSignaturePad)
app.use(Vue3TouchEvents)
app.use(router)
app.provide('axios', axios)
app.component('VDynamicModal', VDynamicModal)
app.mount('#app')
